class MFRBlogGrid {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      grid: ".blog-grid__grid",
      entry: ".blog-grid__entry",
      blogFilters: ".blog-filter",
      blogFilter: ".blog-filter__button",
      selector: ".blog-filter__selector",
      containedFilters: ".blog-grid__sub-filters",
      loadMoreButton: ".blog-grid__button",
      loadMoreN: ".load-more",
    };

    this.scroll = {};

    this.init();
  }

  init() {
    this.$grid = this.$element.find(this.selectors.grid);
    this.$entry = this.$element.find(this.selectors.entry);
    this.$blogFilters = this.$element.find(this.selectors.blogFilters);
    this.$blogFilter = this.$element.find(this.selectors.blogFilters);
    this.$selector = this.$element.find(this.selectors.selector);
    this.$loadMoreButton = this.$element.find(this.selectors.loadMoreButton);
    this.$loadMoreN = this.$element.find(this.selectors.loadMoreN);
    this.$containedFilters = this.$element.find(
      this.selectors.containedFilters
    );

    this.initializeGrid();
    this.setItemsHeight();
    this.resizeIsotope();
    this.initFilters();
    this.initFilterScrollEvents();
    this.updateFilters();
    this.insertCallout();

    this.$blogFilter.on("click", this.__handleFilterChange.bind(this));
    $(window).on("resize", this.updateSelector.bind(this));
    $(window).on("resize", this.initializeGrid.bind(this));

    this.$loadMoreN.on("click", this.__handleLoadMore.bind(this));
  }

  insertCallout() {
    var currentURL = window.location.href;
    var blogName = "reading";
    var blogURL = "https://www.peteandgerrys.com/blogs/field-notes";

    if (currentURL.includes("recipes")) {
      blogName = "recipes";
      blogURL = "https://www.peteandgerrys.com/blogs/recipes";
    }
    var elementToInsert = `
        <div class="blog-grid__entry blog-grid__entry--inserted blog--all" data-order="7" >
        <a data-order="7" class=" blog-card" href="${blogURL}" target="_blank">
        <div class="blog-card__info">
            <div class="blog-card__title">
                <img src="https://cdn.shopify.com/s/files/1/0715/5181/1873/files/pg-chicken.png?v=1712733511" />
                <h2>Can't get enough? fly over to our sister site for more ${blogName}!</h2>
            </div>
        </div>
        </a>
        </div>
        `;

    this.$grid.isotope("insert", $(elementToInsert));
    this.$grid.isotope("layout");
  }
	
  initializeGrid() {
    var iso = this.$grid.isotope({
      itemSelector: this.selectors.entry,
      percentPosition: true,
      percentPosition: false,
      layoutMode: "fitRows",
      fitRows: {
        equalheight: true,
      },
      getSortData: {
        order: "[data-order] parseInt",
      },
      sortBy: "order",
    });
  }
  __handleLoadMore(e) {
    const $grid = this.$grid;
    $(".mfr-blog__grid .blog-grid__entry:hidden")
      .slice(0, 9)
      .show()
      .addClass("is-inview");
    if ($(".mfr-blog__grid .blog-grid__entry:hidden").length == 0) {
      this.$element.find(this.$loadMore).hide();
    }
    this.setItemsHeight();
    $grid.isotope("layout");
    this.setItemsHeight();
  }

  __handleFilterChange(e) {
    if (this.$containedFilters.hasClass("is-scrolling")) return;
    const $button = $(e.target).parent();
    const parent = $button.closest(this.selectors.blogFilters);
    $button.siblings().removeClass("is-active");
    $button.addClass("is-active");
    parent.data("filter", $button.data("filter"));

    this.updateFilters();
  }

  setItemsHeight() {
    this.$element.find(".blog-grid__entry").matchHeight({ byRow: true });
    this.resizeIsotope();
  }

  resizeIsotope() {
    const $grid = this.$grid;

    setTimeout(() => {
      $grid.isotope("layout");
    }, 3000);
  }

  updateFilters() {
    let filtered = [];
    let filterStrings;

    const $noResults = $('<h4 class="no-results">No matches found.</h4>');

    this.$blogFilters.each((i, e) => {
      filtered[i] = $(e).data("filter");
    });

    this.$grid.isotope({
      filter: filtered.toString().replace(",", ""),
    });

    const $gridData = this.$grid.data("isotope");

    if (
      (filtered.length === 2 &&
        filtered.every((val, i, arr) => val === arr[0])) ||
      (filtered.length === 1 && filtered[0] === ".blog--all")
    ) {
      this.$grid.addClass("show-alll-items");
      this.$loadMoreButton.children().show();
    } else {
      this.$grid.removeClass("show-alll-items");
      this.$loadMoreButton.children().hide();
    }

    if ($gridData.filteredItems.length === 0) {
      this.$grid.after($noResults);
    } else {
      $(".no-results").remove();
    }

    this.updateSelector();
  }

  initFilterScrollEvents() {
    const slider = this.$blogFilters.get(0);
    this.scroll.isDown = false;
    this.scroll.startX;
    this.scroll.scrollLeft;

    slider.addEventListener("touchstart", this.__handleScrollStart.bind(this));
    this.$element
      .get(0)
      .addEventListener("touchend", this.__handleScrollEnd.bind(this));
    slider.addEventListener("touchmove", this.__handleScrollMove.bind(this));

    slider.addEventListener("mousedown", this.__handleScrollStart.bind(this));
    this.$element
      .get(0)
      .addEventListener("mouseup", this.__handleScrollEnd.bind(this));
    slider.addEventListener("mousemove", this.__handleScrollMove.bind(this));
  }

  __handleScrollStart(e) {
    const slider = this.$blogFilters.get(0);
    const pageX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
    this.scroll.isDown = true;
    this.scroll.startX = pageX - slider.offsetLeft;
    this.scroll.scrollLeft = slider.scrollLeft;
  }

  __handleScrollEnd(e) {
    const slider = this.$blogFilters.get(0);
    this.scroll.isDown = false;
    setTimeout(() => slider.classList.remove("is-scrolling"), 100);
  }

  __handleScrollMove(e) {
    if (!this.scroll.isDown) return;
    e.preventDefault();
    const slider = this.$blogFilters.get(0);
    const pageX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
    const x = pageX - slider.offsetLeft;
    const walk = (x - this.scroll.startX) * 3; //scroll-fast
    slider.scrollLeft = this.scroll.scrollLeft - walk;
    slider.classList.add("is-scrolling");
  }

  initFilters() {
    this.$blogFilters.each((i, e) => {
      $(e).data(
        "filter",
        $(e)
          .find(this.selectors.blogFilter + ".is-active")
          .data("filter")
      );
    });
    this.updateSelector();
  }

  updateSelector() {
    this.$grid.isotope("layout");

    this.$selector.each((i, e) => {
      const element = $(e)
        .closest(this.selectors.blogFilters)
        .find(this.selectors.blogFilter + ".is-active");
      this.$selector.css({
        left: element.get(0).offsetLeft,
        width: element.outerWidth(),
        height: element.outerHeight(),
      });
    });
  }
}